import React from "react";
import NumberStepperControl from "../../common/NumberStepperControl";
import { MAX_DURATION_HOURS, clampDurationHours } from "../orderFormConstants";
import { OrderFormLocale } from "../types";
import styles from "./orderForm.module.scss";

type DurationStepperProps = {
  locale: OrderFormLocale;
  value: number;
  minHours: number;
  disabled?: boolean;
  onChange: (value: number) => void;
};

const DurationStepper: React.FC<DurationStepperProps> = ({
  locale,
  value,
  minHours,
  disabled = false,
  onChange,
}) => {
  const isFullDay = !disabled && value >= MAX_DURATION_HOURS;
  const minNote = disabled
    ? undefined
    : locale.schedule.durationMinNote.replace("{hours}", String(minHours));

  const helperText = isFullDay ? locale.schedule.durationFullDay : minNote;

  return (
    <div className={styles.durationWrap}>
      <NumberStepperControl
        label={locale.schedule.durationLabel}
        value={value}
        min={disabled ? 0 : minHours}
        max={MAX_DURATION_HOURS}
        step={1}
        disabled={disabled}
        inputReadOnly
        helperText={helperText}
        onChange={(next) => onChange(clampDurationHours(next, minHours))}
        decreaseAriaLabel="Decrease duration"
        increaseAriaLabel="Increase duration"
      />
    </div>
  );
};

export default DurationStepper;
